export default __webpack_public_path__ + "static/media/419.21ffdfce.gif";